export default "__VITE_ASSET__D5epTjy9__"